(function () {
    'use strict';

    angular.module("imApp").factory("p2ExportProcService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 892,
                    parameters: parms || {}
                });
            },
            listTableNames: function (parms) {
                return $ihttp.post({
                    method: 991,
                    parameters: parms || {}
                });
            },
            listEdiTypes: function (parms) {
                return $ihttp.post({
                    method: 2264,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 893,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
